import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';

@Component({
  selector: 'app-sidebar-item-collapsed-hover-subpages',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, RouterLinkActive],
  template: `
    <div class="flex size-full flex-col">
      <span
        class="border-greenish-500 bg-greenish-25 text-greenish-500 dark:bg-greenish-800 w-full rounded-tr-lg border-t border-r border-b px-2.5 py-2">
        {{ mainLabel() }}
      </span>

      <div
        class="chrome--bg element--contrast-border flex w-full flex-col rounded-b-lg border-x border-b">
        @for (subPage of subPages()!; track subPage.path) {
          <a
            routerLink="/{{ subPage.path }}"
            routerLinkActive
            (isActiveChange)="updateActiveRoute(subPage.path, $event)">
            <span
              class="flex w-full cursor-pointer items-center px-2.5 py-2"
              [ngClass]="labelClasses(subPage.path, $first, $last)">
              {{ subPage.label }}
            </span>
          </a>
        }
      </div>
    </div>
  `,
})
export class SidebarItemCollapsedHoverSubpagesComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly service = inject(SidebarService);

  /** PROPERTIES **/
  /****/
  protected readonly mainLabel = this.store.mainLabel;

  /****/
  protected readonly subPages = this.store.subPages;

  /****/
  protected readonly activeRoute = toSignal(this.service.routeChanged$);

  protected labelClasses(path: string, first: boolean, last: boolean) {
    const isActive = path === this.activeRoute();

    const activeText = 'font-medium';
    const activeUnderline = 'underline underline-offset-[0.5em]';
    const activeDecoration = 'decoration-2 decoration-greenish-500';

    const notActiveUnderline = 'hover:underline hover:underline-offset-[0.5em]';
    const notActiveDecoration = `hover:decoration-2 hover:decoration-[var(--text-contrast-base-color)]`;

    const firstPadding = 'pt-3';
    const lastPadding = 'pb-3';

    return {
      [`${activeText} ${activeUnderline} ${activeDecoration}`]: isActive,
      [`${notActiveUnderline} ${notActiveDecoration}`]: !isActive,
      [firstPadding]: first,
      [lastPadding]: last,
    };
  }

  protected updateActiveRoute(route: string, active: boolean) {
    this.service.setActiveRoute(route, active);
  }
}
